import { type ReactNode } from "react";

interface IFooterProps {
  children: ReactNode;
  className?: string;
}

export default function Footer({ children, className = "" }: IFooterProps) {
  return (
    <footer
      className={`fixed bottom-0 left-0 z-40 right-0 bg-general-gray-200 border-t border-general-gray-300 h-20 md:mx-0 px-4 py-3.5 flex items-center ${className}`}
    >
      {children}
    </footer>
  );
}
